/**
 * The callback behind a toast's action button ("Undo"). Kept here, not in the
 * store: Redux state must stay serializable, so a toast carries only the
 * action's id and label, and the function waits in this registry until the
 * button is pressed or the toast goes away.
 */

const callbacks = new Map<string, () => void>();
let sequence = 0;

export const registerToastAction = (run: () => void): string => {
    const id = `toast-action-${Date.now()}-${sequence++}`;
    callbacks.set(id, run);
    return id;
};

/** Run it once; a second press (or a press after the toast went) does nothing. */
export const runToastAction = (id: string): void => {
    const run = callbacks.get(id);
    callbacks.delete(id);
    run?.();
};

export const forgetToastAction = (id: string): void => {
    callbacks.delete(id);
};
